export default [
  {
    path: 'credit-order',
    name: 'list-debt-credit-order',
    component: () =>
      import(/* webpackChunkName: "list-debt-credit-order" */ './List.vue'),
    meta: {
      title: 'Công nợ quẹt thẻ đơn hàng - Clickbuy',
    },
  },
];
